'use client';

import React from 'react';
import type { OrderStatus } from './OrderManagementContent';

const tabs: { id: OrderStatus; label: string; count: number; color: string }[] = [
  { id: 'all', label: 'All Orders', count: 1284, color: 'text-foreground' },
  { id: 'pending', label: 'Pending', count: 14, color: 'text-warning' },
  { id: 'processing', label: 'Processing', count: 28, color: 'text-info' },
  { id: 'shipped', label: 'Shipped', count: 67, color: 'text-purple-600' },
  { id: 'delivered', label: 'Delivered', count: 1108, color: 'text-success' },
  { id: 'cancelled', label: 'Cancelled', count: 42, color: 'text-danger' },
  { id: 'return', label: 'Return / Refund', count: 19, color: 'text-orange-600' },
  { id: 'dispute', label: 'Disputes', count: 6, color: 'text-red-700' },
];

interface OrderStatusTabsProps {
  active: OrderStatus;
  onChange: (status: OrderStatus) => void;
}

export default function OrderStatusTabs({ active, onChange }: OrderStatusTabsProps) {
  return (
    <div className="card overflow-hidden">
      <div className="flex overflow-x-auto scrollbar-thin">
        {tabs.map((tab) => (
          <button
            key={`order-tab-${tab.id}`}
            onClick={() => onChange(tab.id)}
            className={`flex items-center gap-2 px-4 py-3.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-all duration-150 ${
              active === tab.id
                ? 'border-primary text-primary bg-secondary/30' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
            }`}
          >
            <span>{tab.label}</span>
            <span
              className={`text-2xs font-bold px-1.5 py-0.5 rounded-full ${
                active === tab.id
                  ? 'bg-primary text-white'
                  : tab.id === 'pending' ?'bg-warning/20 text-warning'
                  : tab.id === 'dispute' ?'bg-danger/20 text-danger' :'bg-muted text-muted-foreground'
              }`}
            >
              {tab.count.toLocaleString('en-PK')}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}